module.exports = {"title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","legal_headline":"使用者條款與隱私權政策-客戶版","meta":{"description":"GoGoVan快遞App在台灣使用者條款。","og:title":"GoGoVan快遞APP - 使用者條款 | GoGoVan 台灣","og:description":"GoGoVan快遞App在台灣使用者條款。"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/legal/locale.json
// module id = 737
// module chunks = 0 1 2 3 4 5